<template>
  <div class="container">

    <div v-if="loading" class="spinner-loading">
      <spinner></spinner>
    </div>

    <div v-show="!loading">
      <div class="row back-button-row">
        <div class="col-md-12">
          <button type="button" class="btn btn-link" @click="goBack()"><i class="fas fa-arrow-left"></i>
            {{ $t('volver_al_catalogo') }}
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-12">
              <iframe id="iframe-map" :src="mapUrl" @load="iframeLoaded()" allowFullScreen></iframe>
            </div>
          </div>

          <div class="row" style="margin-top: 1rem" v-if="!loading">
            <div class="col-12">

              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="tab in tabs">
                  <a class="nav-link my-tab-item" :class="{active: tabActive === tab.code}" href="javascript:void(0);"
                     @click="tabActive = tab.code">
                    <i :class="['fa', tab.iconCode]"></i>{{ $t(tab.langTag) }}
                  </a>
                </li>
              </ul>

              <div class="tab-content" style="margin-top: 1rem">
                <InfoTab v-if="tabActive === 'info'" :layer="layer"></InfoTab>
                <AttributesTab v-if="tabActive === 'attributes' && attributes !== null"
                               :attributes="attributes"></AttributesTab>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{ $t('descargar_capa') }}</h5>
              <span v-if="layerCode == 'falla'" class="caption mb-2 pa-2"
                    style="color: #ff5722b0;background-color: #ffede7;font-size: 11px">{{
                  $t('catalogo_desactivado')
                }}</span>
              <p class="card-text buttons-download">
              <div v-if="layerCode == 'falla'">
                <a role="button" class="btn btn-primary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">WMS</a>
                <a role="button" class="btn btn-primary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">WFS</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">GeoJSON</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">CSV</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">KML</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">GML</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   target="_blank">Shapefile</a>
              </div>
              <div v-else>
                <a role="button" class="btn btn-primary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="wmsLink" target="_blank">WMS</a>
                <a role="button" class="btn btn-primary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="wfsLink" target="_blank">WFS</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="geojsonLink" target="_blank">GeoJSON</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="csvLink" target="_blank">CSV</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="kmlLink" target="_blank">KML</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="gml3Link" target="_blank">GML</a>
                <a role="button" class="btn btn-secondary btn-sm" :class="{'btn-block': !$mqIn(['xs','sm'])}"
                   :href="shapefileLink"
                   target="_blank">Shapefile</a>
              </div>

              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import {LayersService} from "../../../commons/services/layersService";
import {AppConfig} from "../../../appConfig";
import MediaQueryMixin from "../../../commons/mixins/mediaQueryMixin";
import Spinner from "../../components/Spinner";
import {LayerLinksUtils} from "../../utils/layerLinksUtils";
import {ArrayUtils} from "../../../commons/utils/arrayUtils";
import AttributesTab from "./AttributesTab";
import InfoTab from "./InfoTab";

export default {
  name: 'LayerDetailPage',
  components: {InfoTab, AttributesTab, Spinner},
  mixins: [MediaQueryMixin],
  props: {
    layerCode: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loadingData: true,
    loadingMap: true,
    layer: null,
    attributes: null,
    tabs: [
      {code: 'info', langTag: 'informacion', iconCode: 'fa-info-circle'},
      {code: 'attributes', langTag: 'atributos', iconCode: 'fa-bars'}
    ],
    tabActive: 'info',
  }),
  computed: {
    locale() {
      return this.$i18n.locale
    },
    loading() {
      return this.loadingData || this.loadingMap;
    },
    mapUrl() {
      return `${AppConfig.APP_URL}/${this.locale}/visor/#/?panel=0&layers=${this.layerCode}`;
    },
    kmlLink() {
      return LayerLinksUtils.makeKmlLink(this.layerCode);
    },
    geojsonLink() {
      return LayerLinksUtils.makeGeojsonLink(this.layerCode);
    },
    csvLink() {
      return LayerLinksUtils.makeCsvLink(this.layerCode);
    },
    gml3Link() {
      return LayerLinksUtils.makeGml3Link(this.layerCode);
    },
    shapefileLink() {
      return LayerLinksUtils.makeShapefileLink(this.layerCode);
    },
    wmsLink() {
      return LayerLinksUtils.makeWmsLink(this.layerCode);
    },
    wfsLink() {
      return LayerLinksUtils.makeWfsLink(this.layerCode);
    },
  },
  mounted() {
    this.loadLayer(this.layerCode);
  },
  methods: {
    async loadLayer(layerCode) {
      this.loadingData = true;
      try {
        this.layer = await LayersService.fetchLayerByCode(layerCode);
        this.loadAttributes(this.layer.id);
        this.loadingData = false;
      } catch (e) {
        console.error('Error cargando las capas...');
        this.loadingData = false;
      }
    },
    async loadAttributes(layerId) {
      try {
        this.attributes = await LayersService.fetchLayerAttributes(layerId);
        this.attributes = ArrayUtils.orderByKey(this.attributes, 'orden');
      } catch (e) {
        console.error(e);
      }
    },
    iframeLoaded() {
      this.loadingMap = false;
    },
    goBack() {
      this.$router.replace({path: '/'});
    }
  }
}
</script>

<style lang="scss" scoped>

.container {
  padding-top: 5rem;
  margin-bottom: 2rem;
}

.spinner-loading {
  height: 300px;

  @media (min-width: 768px) {
    height: 600px;
  }
}

iframe#iframe-map {
  border: none;
  width: 100%;
  height: 400px;

  @media (max-width: 768px) {
    height: 200px;
  }
}

/*.dl-horizontal {*/
/*dt {*/
/*text-overflow: clip;*/
/*white-space: normal;*/
/*overflow: hidden;*/
/*}*/

/*@media (min-width: 768px) {*/
/*dt {*/
/*float: left;*/
/*width: 160px;*/
/*clear: left;*/
/*text-align: right;*/
/*overflow: hidden;*/
/*text-overflow: ellipsis;*/
/*white-space: nowrap;*/
/*}*/
/*dd {*/
/*margin-left: 180px;*/
/*}*/
/*}*/
/*}*/

.buttons-download {
  .btn {
    margin-bottom: 0.3rem;
  }
}

.back-button-row {
  margin-bottom: 1rem;
}

.my-tab-item {
  i {
    padding-right: 6px;
  }
}
</style>